import React from 'react';
import PropTypes from 'prop-types';

import { dateTimeSlashesFormat, formatUtcDate } from 'App/services/DateService';

const propTypes = {
    activityHistory: PropTypes.arrayOf(
        PropTypes.shape({
            createdName: PropTypes.shape({
                firstName: PropTypes.string,
                lastName: PropTypes.string,
            }),
            sentOn: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
            referralActivityStatus: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
        })
    ),
};

const defaultPropTypes = {
    activityHistory: [],
};

const ReferralActivityHistory = ({ activityHistory }) => (
    <div>
        {activityHistory?.length ? (
            activityHistory.map(({ createdName, sentOn, referralActivityStatus, id }) => {
                const { firstName = '--', lastName = '--' } = createdName || {};
                const parsedSentOn = formatUtcDate({ date: sentOn instanceof Date ? sentOn : new Date(sentOn), format: dateTimeSlashesFormat });
                const sentOnDisplay = sentOn ? parsedSentOn : '"Sending In Progress"';
                return (
                    <p key={id}>
                        {`Note sent to EHR: Yes; by ${firstName} ${lastName} on ${sentOnDisplay} status ${referralActivityStatus}`}
                    </p>
                );
            })
        ) : (
            <div>
                <p>Note sent to EHR: No</p>
            </div>
        )}
    </div>
);

ReferralActivityHistory.propTypes = propTypes;
ReferralActivityHistory.defaultProps = defaultPropTypes;

export default ReferralActivityHistory;
